import React, { useEffect, useState } from 'react';

import moment from 'moment';
import { formatNumber } from '../../../../../utility/helper';

const RechartExample = ({ fortuneData }) => {

  return (
    <div className="flex gap-4">
      <div className="w-full">
        <div className="text-white px-12 mt-6 mb-16 rounded-lg w-fit flex flex-col">
          <table className="w-full text-md border-collapse">
            <thead>
              <tr>
                <th className="text-left pr-4"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pr-4 pb-4">Your fortune is now valued at</td>
                <td className="pr-4 pb-4 text-cyan-400">CHF</td>
                <td className="text-cyan-400 pb-4">{formatNumber(fortuneData?.fortune_value ?? "#######")}</td>
              </tr>
              <tr>
                <td className="pr-4 pb-4">The fortune has increased by</td>
                <td className="pr-4 text-cyan-400 pb-4">CHF</td>
                <td className="text-cyan-400 pb-4">{formatNumber(fortuneData?.fortune_increased ?? "#######")}</td>
                <td className="pl-4 pb-4">Year to date</td>
              </tr>
              <tr>
                <td className="pr-4 pb-4">Due to total profit of</td>
                <td className="pr-4 text-cyan-400 pb-4">CHF</td>
                <td className="text-cyan-400 pb-4">{formatNumber(fortuneData?.due_total ?? "#######")}</td>
                <td className="pl-4 text-cyan-400 text-center pb-4">16%</td>
                <td className="px-4 pb-4">and a net flow of</td>
                <td className="pr-4 text-cyan-400 pb-4">CHF</td>
                <td className="text-cyan-400 pb-4">{formatNumber(fortuneData?.net_flow ?? "#######")}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RechartExample;
